import {
  PaymentType,
  PaymentDataLayerSku,
  PaymentDataLayerName,
  type PaymentDataLayer
} from '@/types'

const SOFT_PAYMENT_LIMIT = 1000

const DEFAULT_INSTALMENT_AND_FUNDRAISING_AMOUNT = 200

const PAYMENT_DATALAYER_LOCAL_STORAGE_KEY = 'gtmInfo'

const PAYMENT_DATALAYER: PaymentDataLayer = {
  [PaymentType.purchase]: {
    sku: PaymentDataLayerSku.purchase,
    name: PaymentDataLayerName.purchase
  },
  [PaymentType.instalments]: {
    sku: PaymentDataLayerSku.instalments,
    name: PaymentDataLayerName.instalments
  },
  [PaymentType.fundraising]: {
    sku: PaymentDataLayerSku.fundraising,
    name: PaymentDataLayerName.fundraising
  },
  [PaymentType.fundraisingDonate]: {
    sku: PaymentDataLayerSku.fundraisingDonate,
    name: PaymentDataLayerName.fundraisingDonate
  }
}

const PAYMENT_STATUS = {
  waiting: 1,
  paid: 4
}

export {
  SOFT_PAYMENT_LIMIT,
  DEFAULT_INSTALMENT_AND_FUNDRAISING_AMOUNT,
  PAYMENT_DATALAYER,
  PAYMENT_DATALAYER_LOCAL_STORAGE_KEY,
  PAYMENT_STATUS
}
